/** sessionStorage key aligned with dashboard `/kanban/wallet/info` response */
export const WALLET_INFO_CACHE_PREFIX = 'walletInfo_'

export function writeWalletInfoCache(btPlatformId, result) {
  if (btPlatformId == null || btPlatformId === '') return
  try {
    sessionStorage.setItem(
      WALLET_INFO_CACHE_PREFIX + btPlatformId,
      JSON.stringify({ result, ts: Date.now() })
    )
  } catch (e) {
    /* ignore quota */
  }
}

export function readWalletInfoCache(btPlatformId) {
  if (btPlatformId == null || btPlatformId === '') return null
  try {
    const raw = sessionStorage.getItem(WALLET_INFO_CACHE_PREFIX + btPlatformId)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && parsed.result ? parsed.result : null
  } catch (e) {
    return null
  }
}

export function clearWalletInfoCache(btPlatformId) {
  if (btPlatformId == null || btPlatformId === '') return
  sessionStorage.removeItem(WALLET_INFO_CACHE_PREFIX + btPlatformId)
}

export function getBtPlatformIdFromSelectedPlatform() {
  try {
    const p = JSON.parse(sessionStorage.getItem('selectedPlatform') || '{}')
    if (p.btPlatformId != null && p.btPlatformId !== '') return p.btPlatformId
    if (p.id != null && p.id !== '') return p.id
  } catch (e) {
    /* ignore */
  }
  return null
}

export function hasAuthToken() {
  return !!(
    window.localStorage.getItem('Token') ||
    window.sessionStorage.getItem('Token')
  )
}
